import axios from "axios";

const KEY = "sandro_visitor_id";

export const getVisitorId = () => {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = (crypto.randomUUID?.() || String(Date.now()) + Math.random().toString(36).slice(2));
    localStorage.setItem(KEY, id);
  }
  return id;
};

export const trackVisit = (path) => {
  const api = `${process.env.REACT_APP_BACKEND_URL}/api`;
  axios.post(`${api}/track`, { path, visitor_id: getVisitorId() }).catch(() => {});
};
